export type User = {
  id: string;
  fullName: string;
  username: string;
  email: string;
  roles: UserRole[];
  yandexUid: string | null;
  accessTokenExpiresAt: string | null;
};

export enum UserRole {
  admin = 'admin',
}

/** Получить Yandex провайдер ID пользователя для запросов к Yandex Tracker API */
export const getYandexUserId = (user: User): string | null => {
  return user.yandexUid;
};
